export default function activationsRepo($http, appSettings) {
  'ngInject';

  const base = `${appSettings.InReachApiInstallationsEndpoint}`;

  this.createSyncRequest = function(installationId, runHours) {
    let req = {
      method: 'POST',
      url: `${base}/${installationId}/runhours`,
      data: JSON.stringify({
        value: runHours
      })
    };
    return $http(req);
  };
}
